import { Link } from 'react-router-dom-v5-compat';

import AttributeItem, { AttributeGrid } from 'dashboard/components/AttributeItem';
import { ReportBusinessAssociatedPersons } from 'dashboard/models/report/business-associated-persons';

interface BusinessAssociatedPersonsProps {
  report: ReportBusinessAssociatedPersons;
  isRedacted: boolean;
}

export const BusinessAssociatedPersons = ({
  report: {
    attributes: {
      metadata: { 'database-business-token': databaseBusinessToken },
    },
  },
  isRedacted,
}: BusinessAssociatedPersonsProps) => {
  return (
    <AttributeGrid>
      <AttributeItem
        title='Verified Business Record'
        value={
          <Link to={`/dashboard/verifications/${databaseBusinessToken}`}>
            {databaseBusinessToken}
          </Link>
        }
        isRedacted={isRedacted}
      />
    </AttributeGrid>
  );
};
